import React, { Component } from 'react';
import { Row,FormGroup,FormControl } from 'react-bootstrap';
import MaskedInput from 'react-text-mask';
import Logo from '../../Helper/Logo/logo';
import load from 'load-script';
import validations from '../../Helper/Validations';
import Back from "../../Helper/Back/back";
import  axiosI  from '../../Service/service';
import LoginModal from './appLogin';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import * as constants from '../../Constants';

const styles={
    Button: {
        color: '#fff',
        borderRadius: '5px',
        fontSize:'medium',
        marginBottom:'3%',
        textTransform:'none'
    },
    disabledButton: {
        color: '#fff',
        borderRadius: '5px',
        fontSize:'medium',
        marginBottom:'3%',
        textTransform:'none',
        opacity:0.6,
        '&:hover':{
            backgroundColor:'#851679',
            opacity:0.6,
            cursor:'auto'
        }
    },
};

class PersonalDetails extends Component {
    constructor(props){
        super(props);
        this.state={
            lblErrorMsg:'',
            lblPhoneNoMsg:'',
            data:{showMsg:false},
            showLoginScreen:false,
          callBusinessForm:false
        }
    }

    componentWillMount() {
        if (this.props.data) {
          const {data} = this.props;
          if (Object.keys(data).length > 0) {
            this.setState({
              data
            })
          }
        }
      load('https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyBr9MSaEjodT_Q9bnUqUcusJ8HWmQmJRC0', () => {
        this.setState({
          callBusinessForm: true
        })
      });

    }

    showLoginScreen=()=>{

        this.setState({
            showLoginScreen:true
        })
    };

    closeLoginScreen=()=>{
        this.setState({
            showLoginScreen:false
        });
    };

    checkEmpty=()=>{
        let {data,lblErrorMsg,lblPhoneNoMsg} = this.state;
        if(!data.PhoneNo) {
            return false;
        }
        return (Object.keys(data).length>=3 && data.PhoneNo!=='' && data.Email!=='' && lblErrorMsg==="" &&
        lblPhoneNoMsg === "" && !data.showMsg)
    };

    handleChange=(e)=>{
        const { name,value } = e.target;
        let { data, lblErrorMsg, lblPhoneNoMsg } = this.state;
        if(name==='Email'){
            data.showMsg=false;
            lblErrorMsg=validations.validateEmail(value);
          data[name]=value;
        }
        if(name==='PhoneNo'){
            lblPhoneNoMsg=this.validatePhoneNo(value)
          data[name]=value.replace(/\D/g,'');
        }
        this.setState({ data, lblErrorMsg, lblPhoneNoMsg })
    };

    validatePhoneNo=(phoneNo)=>{
        phoneNo=phoneNo.replace(/\D/g,'');
        if(phoneNo.length<10){
           return 'Phone No. Must Contains 10 Digits.'
        }
        else
            return '';
    };

    onNext=()=>{
        const { data } = this.state;
        let Email= data.Email;
        let PhoneNo= data.PhoneNo;
        let stateData=data;
        let msg=validations.validateEmail(Email);
        if(msg === "") {
            axiosI.get(`${constants.API.verifyAccountEmailApi}/${Email}`).then(({data}) => {
                if (!data.results.ResponseCode) {
                    stateData.showMsg=true;
                    this.setState({
                        data:stateData
                    });
                } else {
                    if(this.checkEmpty() && (PhoneNo.length > 9 )) {
                        axiosI.get(`${constants.API.verifyAccountPhonenumberApi}/${PhoneNo}`).then(({data}) => {

                            if (!data.results.ResponseCode) {
                                stateData.showMsg=true;
                                this.setState({
                                    lblPhoneNoMsg: 'Phone No. Already Exist'
                                });
                            } else {
                                if(PhoneNo.length < 10) {
                                    this.setState({ lblPhoneNoMsg: 'Phone No. Must Contains 10 Digits.' })
                                }
                                else {
                                    this.setState({ lblPhoneNoMsg: '' });
                                    this.props.next(this.state.data);
                                }
                            }
                        });
                    }
                }
            });
        }
    };

    onPrevious=()=>{
        this.props.onPrevious(this.state.data);
    };

    verifyEmail=()=>{
        let Email=this.state.data.Email;
        const { data } = this.state;
        let stateData=data;
        let msg=validations.validateEmail(Email);
        this.setState({
            lblErrorMsg: msg
        });
        if(msg==='') {
            axiosI.get(`${constants.API.verifyAccountEmailApi}/${Email}`).then(({data}) => {
                if (!data.results.ResponseCode) {
                    stateData.showMsg=true;
                    this.setState({
                        data:stateData
                    });
                } else {
                    this.setState({
                        lblErrorMsg: ''
                    });
                }
            });
        }
    };

    verifyPhoneNo=(e)=>{
        let value=e.target.value;
        let phoneNo=value.replace(/\D/g,'');
            axiosI.get(`${constants.API.verifyAccountPhonenumberApi}/${phoneNo}`).then(({data}) => {

                if (!data.results.ResponseCode) {
                    this.setState({
                        lblPhoneNoMsg: 'Phone No. Already Exist'
                    });
                } else {
                    if(phoneNo.length < 10) {
                        this.setState({ lblPhoneNoMsg: 'Phone No. Must Contains 10 Digits.' })
                    }
                    else {
                        this.setState({ lblPhoneNoMsg: '' });
                    }
                }
            });
    };

    render(){
        const { lblErrorMsg ,data, lblPhoneNoMsg } = this.state;
        const { classes } = this.props;
        return(
          <div> {this.state.callBusinessForm &&
          <section className="container">
              <Row>
                  <div className="col-12 text-center">
                      <Back onPrevious={this.onPrevious}/>
                      <Logo/>
                  </div>
                  <FormGroup className="col-12">
                      <h2 className='subHeading' style={{textOverflow: 'ellipsis'}}>Nice to meet
                          you {this.state.data.Name}!</h2>
                      <div className="error">
                        {
                          (lblErrorMsg !== '' || lblPhoneNoMsg !== '') ?
                            <span>{lblErrorMsg ? lblErrorMsg : lblPhoneNoMsg}</span> : <span/>
                        }
                      </div>
                      <FormGroup>
                          <FormControl type={'email'} placeholder="Your Business Email Address"
                                       name="Email"
                                       value={data.Email}
                                       onBlur={this.verifyEmail}
                                       onChange={this.handleChange}
                          />
                      </FormGroup>
                      <FormGroup>
                          <MaskedInput
                            mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                            className="form-control"
                            placeholder="Your Business Phone Number"
                            guide={false}
                            showMask={false}
                            name={'PhoneNo'}
                            id={'contact'}
                            onBlur={this.verifyPhoneNo}
                            value={data.PhoneNo}
                            onChange={this.handleChange}
                          />
                      </FormGroup>
                      <FormGroup>
                        {
                          (this.state.data.showMsg) ?
                            <span>Email is already in use.Please <a onClick={this.showLoginScreen}>Click here</a> to Log in.</span>
                            :
                            (lblPhoneNoMsg==="Phone No. Already Exist")
                              ?
                              <span>Phone number is already in use.Please <a onClick={this.showLoginScreen}>Click here</a> to Log in.</span>
                              :
                              <span/>
                        }
                      </FormGroup>
                      <FormGroup className="text-right mt-50">
                          <Button className={(this.checkEmpty()) ? classes.Button : classes.disabledButton}
                                  onClick={this.onNext}
                                  color={'primary'} variant={'contained'}
                          >Next</Button>
                      </FormGroup>
                  </FormGroup>
              </Row>
              < LoginModal show={this.state.showLoginScreen} hide={this.closeLoginScreen}
                           next={this.props.next} data={this.state.data}
                           history={this.props.history}
              />

          </section>
          }
          </div>
        )
    }
}
export default withStyles(styles)(PersonalDetails);